import classNames from "classnames";
import { forwardRef, MouseEvent, PropsWithChildren, ReactNode } from "react";
import SvgEdit from "../icons/Edit";
import styles from "./Box.module.css";
import Button from "./Button";
import Icon from "./Icon";

interface BoxProps extends PropsWithChildren {
  title?: string;
  subtitle?: ReactNode;
  onClick?: (event: MouseEvent<HTMLTableRowElement | HTMLDivElement>) => void;
  button?: {
    title: string;
    onClick: () => void;
    type?: string;
  };
  showEditButton?: boolean;
  type?: "primary" | "secondary";
  footer?: ReactNode;
  isScrollableBody?: boolean;
  fullHeight?: boolean;
}

const Box = forwardRef<HTMLDivElement, BoxProps>(
  (
    {
      title,
      subtitle,
      onClick,
      button,
      children,
      showEditButton,
      type = "primary",
      fullHeight,
      footer,
      isScrollableBody = false,
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={classNames(styles.box, {
          [styles.primary]: type === "primary",
          [styles.secondary]: type === "secondary",
          [styles["full-height"]]: !!fullHeight,
        })}
      >
        {(showEditButton || title) && (
          <div className={styles.header}>
            <div className={styles.rowContainer}>
              <h3 onClick={onClick}>{title}</h3>
              {!!showEditButton && (
                <span className={styles.statusEdit} onClick={onClick}>
                  <Icon glyph={SvgEdit} />
                </span>
              )}
              {button && (
                <Button
                  buttonProps={{
                    onClick: button?.onClick,
                    className: styles.pushRight,
                  }}
                >
                  {button?.title}
                </Button>
              )}
            </div>
            {!!subtitle && <div>{subtitle}</div>}
          </div>
        )}
        {isScrollableBody ? <div className={styles.scrollableBody}>{children}</div> : <>{children}</>}
        {!!footer && <div className={styles.footer}>{footer}</div>}
      </div>
    );
  },
);

export default Box;
